<template>
  <v-dialog
    v-model="dialog"
    width="640"
  >
    <v-card>
      <v-card-title style="background-color: #214762;
    text-align: center;
    display: block;
    color: #fff;
    margin: 0 auto;
    padding: 10px 0;">
        Pagamento do curso
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          on-submit="return false;"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <div class="card-mundiplay">
                <img src="@/assets/mundi-play-card-chip.png" class="chip-cartao" alt="chip cartao">
                <v-img class="bandeira-cartao" v-if="flagImage" :src="require(`@/assets/cards/${flagImage}`)"></v-img>
                <!-- <v-img class="bandeira-cartao" v-else src="@/assets/cards/mundiplay.png"></v-img> -->

                <p class="numero-cartao">
                  <template v-if='number'>
                    {{ number }}
                  </template>
                  <template v-else>
                    #### #### #### ####
                  </template>
                </p>

                <div class="nome-cartao">
                  <p>Nome no cartão</p>
                  <p v-if="name">{{ name }}</p>
                  <p v-else>Nome no cartão</p>
                </div>

                <div class="data-cartao">
                  <p>Válido até</p>
                  <p v-if="expMonth || expYear">{{ expMonth }}/{{ expYear }}</p>
                  <p v-else>00/0000</p>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="payment-card-info">
            <v-col cols="12" md="12">
              <v-text-field
                v-model="number"
                :loading="loading"
                :rules="numberRules"
                v-mask="maskNumber"
                label="Número do cartão"
                placeholder="Digite o número do seu cartão"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="8">
              <v-text-field
                v-model="name"
                :loading="loading"
                :rules="nameRules"
                :value="maskName"
                label="Nome do titular"
                placeholder="Preencha o nome como esta no cartão"
                required
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="cpf"
                :loading="loading"
                :rules="cpfRules"
                v-mask="'###.###.###-##'"
                label="CPF do titular"
                placeholder="000.000.000-00"
                required
                @keyup.enter="send"
              />
            </v-col>

            <!-- @keyup.enter="send" -->

            <v-col cols="12" md="4">
              <v-text-field
                v-model="cvv"
                :loading="loading"
                :rules="cvvRules"
                v-mask="maskCVV"
                label="CVV"
                placeholder=" "
                required
                @keyup.enter="send"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="expMonth"
                :items="months"
                item-value="number"
                item-text="text"
                :loading="loading"
                :rules="expMonthRules"
                label="Mês do vencimento"
                placeholder="Informe o mês"
                required
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="expYear"
                :items="years"
                :loading="loading"
                :rules="expYearRules"
                label="Ano do vencimento"
                placeholder="Informe o ano"
                required
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="installment"
                :items="installments"
                item-value="number"
                item-text="text"
                :loading="loading"
                label="Parcelamento"
                required
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                class="price-course"
                v-model="valueInstallment"
                :disabled="true"
                :label="valueLabel"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="pt-0">
        <v-col cols="12" md="12" class="pt-0">
          <v-btn
            :loading="loading"
            :disabled="loading"
            color="primary"
            class="w100 button-card"
            @click="send"
          >
            Enviar
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const credCardRules = [
  {
    mask: '#### ###### #####',
    cvv: '####',
    regex: '^3[47]\\d{0,13}',
    cardtype: 'AMEX',
    image: 'amex.png'
  },
  {
    mask: '####-####-####-####',
    cvv: '###',
    regex: '^(5019|4175|4571)\\d{0,12}',
    cardtype: 'DANKORT',
    image: 'dankort.png'
  },
  {
    mask: '#### ###### ####',
    cvv: '###',
    regex: '^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}',
    cardtype: 'DINERS',
    image: 'diners.png'
  },
  {
    mask: '#### #### #### ####',
    cvv: '####',
    regex: '^(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}',
    cardtype: 'DISCOVER',
    image: 'discover.png'
  },
  {
    mask: '#### #### #### ####',
    cvv: '###',
    // regex: '/^[456](?:011|38935|51416|576|04175|067|06699|36368|36297)\\d{10}(?:\\d{2})?$/',
    regex: '^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^504175|^627780|^63(6297|6368|6369)|(65003[5-9]|65004[0-9]|65005[01])|(65040[5-9]|6504[1-3][0-9])|(65048[5-9]|65049[0-9]|6505[0-2][0-9]|65053[0-8])|(65054[1-9]|6505[5-8][0-9]|65059[0-8])|(65070[0-9]|65071[0-8])|(65072[0-7])|(65090[1-9]|6509[1-6][0-9]|65097[0-8])|(65165[2-9]|6516[67][0-9])|(65500[0-9]|65501[0-9])|(65502[1-9]|6550[34][0-9]|65505[0-8])|^(506699|5067[0-6][0-9]|50677[0-8])|^(509[0-8][0-9]{2}|5099[0-8][0-9]|50999[0-9])|^65003[1-3]|^(65003[5-9]|65004\\d|65005[0-1])|^(65040[5-9]|6504[1-3]\\d)|^(65048[5-9]|65049\\d|6505[0-2]\\d|65053[0-8])|^(65054[1-9]|6505[5-8]\\d|65059[0-8])|^(65070\\d|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091\\d|650920)|^(65165[2-9]|6516[6-7]\\d)|^(65500\\d|65501\\d)|^(65502[1-9]|6550[3-4]\\d|65505[0-8])',
    cardtype: 'ELO',
    image: 'elo.png'
  },
  {
    mask: '#### #### #### ####',
    cvv: '###',
    regex: '^606282|^637095|^637599|^637568',
    cardtype: 'HIPERCARD',
    image: 'hipercard.png'
  },
  {
    mask: '####-####-####-####',
    cvv: '###',
    regex: '^63[7-9]\\d{0,13}',
    cardtype: 'INSTAPAYMENT'
  },
  {
    mask: '#### ###### #####',
    cvv: '###',
    regex: '^(?:2131|1800)\\d{0,11}',
    cardtype: 'JCB15',
    image: 'jcb.png'
  },
  {
    mask: '#### #### #### ####',
    cvv: '###',
    regex: '^(?:35\\d{0,2})\\d{0,12}',
    cardtype: 'JCB',
    image: 'jcb.png'
  },
  {
    mask: '#### #### #### ####',
    cvv: '###',
    regex: '^(?:5[0678]\\d{0,2}|6304|67\\d{0,2})\\d{0,12}',
    cardtype: 'MAESTRO',
    image: 'maestro.png'
  },
  {
    mask: '#### #### #### ####',
    cvv: '###',
    regex: '^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}',
    cardtype: 'MASTER',
    image: 'master.png'
  },
  {
    mask: '####-####-####-####',
    cvv: '###',
    regex: '^220[0-4]\\d{0,12}',
    cardtype: 'MIR',
    image: 'mir.png'
  },
  {
    mask: '#### #### #### ####',
    cvv: '###',
    regex: '^4\\d{0,15}',
    cardtype: 'VISA',
    image: 'visa.png'
  },
  {
    mask: '#### #### #### ####',
    cvv: '###',
    regex: '^62\\d{0,14}',
    cardtype: 'UNIONPAY',
    image: 'unionpay.png'
  }
]

import { mask } from 'vue-the-mask'
import { isValidCPF, months, numberFormat } from '@/helpers'

export default {
  name: 'ModalCoursePayment',
  directives: { mask },
  props: {
    show: {
      default: false
    },
    price: {
      required: true
    },
    courseId: {
      required: false
    },
    passOnTax: {
      required: false,
      default: false
    }
  },
  data: () => {
    return {
      value: 0,
      loading: false,
      valid: false,
      creditCardTax: [],
      number: '',
      cvv: '',
      name: '',
      cpf: '',
      expMonth: '',
      expYear: '',
      installment: 1,
      installments: [
        { number: 1, text: 'A vista' },
        { number: 2, text: '2 vezes' },
        { number: 3, text: '3 vezes' },
        { number: 4, text: '4 vezes' },
        { number: 5, text: '5 vezes' },
        { number: 6, text: '6 vezes' },
        { number: 7, text: '7 vezes' },
        { number: 8, text: '8 vezes' },
        { number: 9, text: '9 vezes' },
        { number: 10, text: '10 vezes' },
        { number: 11, text: '11 vezes' },
        { number: 12, text: '12 vezes' },
      ],
      flag: '',
      flagImage: null,
      months,
      numberRules: [
        v => !!v || 'Preencha o número do cartão',
      ],
      cvvRules: [
        v => !!v || 'Preencha o CVV',
      ],
      nameRules: [
        v => !!v || 'Preencha o nome do titular',
      ],
      expMonthRules: [
        v => !!v || 'Selecione o mês do vencimento',
      ],
      expYearRules: [
        v => !!v || 'Selecione o ano do vencimento',
      ],
      cpfRules: [
        v => !!v || 'Preencha o CPF',
        v => isValidCPF(v) || 'CPF Inválido',
      ],
      maskNumber: '#### #### #### ####',
      maskCVV: '###',
      // maskName: 'AAA'
    }
  },
  watch: {
    number (number) {
      if (number) {
        const cardRules = credCardRules.filter(rule => {
          const reg = new RegExp(rule.regex)

          return number.replace(/\D/g, '').match(reg)
        })

        if (cardRules.length) {
          let cardRule = cardRules[0]

          if (cardRules.length > 1) {
            cardRule = cardRules.find(rule => {
              return rule.cardtype !== 'VISA'
            })
          }

          this.flag = cardRule.cardtype
          this.maskNumber = cardRule.mask
          this.maskCVV = cardRule.cvv

          if (cardRule.image) {
            this.flagImage = cardRule.image
          }

          return false
        }
      }

      this.flag = ''
      this.flagImage = null
      this.maskNumber = '#### #### #### ####'
      this.maskCVV = '###'
    }
  },
  computed: {
    dialog: {
      get: function () {
        return this.show
      },
      set: function (val) {
        if (!val) {
          this.$emit('close')
        }
      }
    },
    years: function () {
      const years = [],
        year = new Date().getFullYear(),
        limitYear = year + 10

      for (let i = year; i <= limitYear; i++) {
        years.push(i)
      }

      return years
    },
    valueLabel: function () {
      if (this.installment > 1) {
        return 'Valor da parcela'
      }

      return 'Valor a vista'
    },
    valueInstallment: function () {
      const valueInstallment = (this.price / this.installment)

      if (!this.passOnTax) {
        return `R$ ${numberFormat((Math.ceil(valueInstallment * 100) / 100), '2', ',', '.')}`
      }

      const tax = this.creditCardTax.find(tax => tax.installment === this.installment),
        taxValue = (tax ? tax.value : 0)

      const valueInstallmentWithTax = Math.ceil((((taxValue * valueInstallment) / 100) + valueInstallment) * 100) / 100

      const total = valueInstallmentWithTax * this.installment

      console.log('valueInstallmentWithTax', valueInstallmentWithTax)
      console.log('total', total)
      console.log('this.price', this.price)
      console.log('this.installment', this.installment)
      console.log('this.passOnTax', this.passOnTax)
      console.log('taxValue', taxValue)

      return `R$ ${numberFormat(valueInstallmentWithTax, '2', ',', '.')}`
    },
    maskName: function () {
      // return /^(?:[0-9a-zA-Z]+\s?)*$/g.exec(this.name.toUpperCase())
      return this.name.toUpperCase().replace(/^(?:[0-9a-zA-Z]+\s?)*$/gi, '')
    }
  },
  created () {
    this.getCreditCardTax()
  },
  methods: {
    getCreditCardTax () {
      this.loading = true

      this.axios.get('/user/payment/credit-card-tax').then(({ data }) => {
        this.creditCardTax = data.taxes
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loading = false
      })
    },
    send () {
      if (this.$refs.form.validate()) {
        this.loading = true

        const postData = {
          creditCardData: {
            number: this.number,
            brand: this.flag,
            cvv: this.cvv,
            name: this.name,
            cpf: this.cpf,
            expMonth: this.expMonth,
            expYear: this.expYear,
            installment: this.installment
          }
        }

        if (this.courseId) {
          postData.courseId = this.courseId
        }

        this.axios.post('/user/payment/course', postData).then(({ data }) => {
          if (data.success) {
            this.$swal('Parabéns!', 'Curso adquirido com sucesso.<br>Vamos começar?', 'success').then(() => {
              if (this.courseId) {
                this.$router.push({ name: 'take-course', params: { course_id: this.courseId } })
              }
            })
          } else {
            const message = (data.message || 'Erro ao efetuar o pagamento')

            this.$swal('Ops', message, 'error')
          }
        }).catch(err => {
          console.error(err)

          this.$swal('Ops', 'Erro ao efetuar o pagamento', 'error')
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
